import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
import * as c from "../../common/config/AppConstants";
import * as fo from "../../common/FormatFunctions";
import * as fl from "./FilterFunctions";

export class Employees extends Component {
  constructor() {
    super();
    this.state = {
      //Loading
      loaded: false,
      editLoaded: true,
      //Display
      userSelected: false,
      userEdited: false,
      userAdded: false,
      userDeleted: false,
      //Details
      userList: [],
      selectedUser: "",
      userAddressLine1: "",
      userAddressLine2: "",
      userCodeTag: "",
      userContactTelephone: "",
      userDateCreated: "",
      userEmail: "",
      userFirstName: "",
      userId: "",
      userLastUpdatedDateTime: "",
      userPin: "",
      userPostcode: "",
      userRoleType: "",
      userSurname: "",
      userTown: "",
      //Edit Details
      editedUserAddressLine1: "",
      editedUserAddressLine2: "",
      editedUserContactTelephone: "",
      editedUserEmail: "",
      editedUserFirstName: "",
      editedUserPin: "",
      editedUserPostcode: "",
      editedUserRoleType: "",
      editedUserSurname: "",
      editedUserTown: "",
      //Other
      userPinList: []
    };
  }

  componentDidMount = () => {
    this.getUsers();
  };

  getUsers = async () => {
    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("codeTag");
    userRequest.userId = localStorage.getItem("userId");

    await api("userApiV1UserListInBusiness", userRequest).then(res => {
      if (res.data.users) {
        res.data.users.forEach(e => {
          if (e.lastUpdatedDateTime) {
            //e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
          }
          if (e.dateCreated) {
            //e.dateCreated = e.dateCreated.toJSON();
          }
        });
      }

      let userResponse = CloudService.UserResponse.constructFromObject(
        res.data
      );
      console.log(userResponse);

      if (userResponse.errorCode === 0) {
        this.setState(
          {
            userList: userResponse.users
          },
          () => {
            this.setPinList();
          }
        );
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving users, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true, editLoaded: true });
  };

  setPinList = () => {
    if (this.state.userList) {
      let userPinList = [];
      this.state.userList.forEach(e => {
        userPinList.push(e.pin);
      });
      this.setState({ userPinList: userPinList }, () => {
        this.reselectUser();
      });
    }
  };

  checkPin = () => {
    let check = false;

    if (
      this.state.userAdded === true ||
      this.state.editedUserPin !== this.state.userPin
    ) {
      this.state.userPinList.forEach(e => {
        if (this.state.editedUserPin === e) {
          check = true;
        }
      });
    }

    return check;
  };

  updateUser = async () => {
    this.setState({ editLoaded: false });

    if (this.checkPin() === true) {
      this.setState({ editLoaded: true }, () => {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "The PIN entered is already in use, please enter another PIN",
          life: 3000
        });
      });
    } else {
      let userRequest = new CloudService.UserRequest();
      userRequest.codeTag = localStorage.getItem("codeTag");
      userRequest.userId = localStorage.getItem("userId");
      userRequest.id = this.state.userId;
      userRequest.lastUpdatedDateTime = this.state.userLastUpdatedDateTime;
      userRequest.firstName = this.state.editedUserFirstName;
      userRequest.surname = this.state.editedUserSurname;
      userRequest.email = this.state.editedUserEmail;
      userRequest.contactTelephone = this.state.editedUserContactTelephone;
      userRequest.addressLine1 = this.state.editedUserAddressLine1;
      userRequest.addressLine2 = this.state.editedUserAddressLine2;
      userRequest.town = this.state.editedUserTown;
      userRequest.postcode = this.state.editedUserPostcode;
      userRequest.pin = this.state.editedUserPin;
      userRequest.roleType = this.state.editedUserRoleType;

      await api("userApiV1UserUpdateAccount", userRequest).then(res => {
        if (res.data.lastUpdatedDateTime) {
          //res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse = CloudService.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            userEdited: false
          });
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "User successfully updated",
            life: 3000
          });
          let typeOfUpdate = 1;
          this.updateUserList(userResponse, typeOfUpdate);
        } else {
          this.setState({ editLoaded: true });
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "An error occured updating the user, please try again",
            life: 3000
          });
        }
      });
    }
  };

  addUser = async () => {
    this.setState({ editLoaded: false });

    if (this.checkPin() === true) {
      this.setState({ editLoaded: true }, () => {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "The PIN entered is already in use, please enter another PIN",
          life: 3000
        });
      });
    } else {
      let userRequest = new CloudService.UserRequest();
      userRequest.codeTag = localStorage.getItem("codeTag");
      userRequest.userId = localStorage.getItem("userId");
      userRequest.firstName = this.state.editedUserFirstName;
      userRequest.surname = this.state.editedUserSurname;
      userRequest.email = this.state.editedUserEmail;
      userRequest.contactTelephone = this.state.editedUserContactTelephone;
      userRequest.addressLine1 = this.state.editedUserAddressLine1;
      userRequest.addressLine2 = this.state.editedUserAddressLine2;
      userRequest.town = this.state.editedUserTown;
      userRequest.postcode = this.state.editedUserPostcode;
      userRequest.pin = this.state.editedUserPin;
      userRequest.roleType = this.state.editedUserRoleType;

      await api("userApiV1UserCreate", userRequest).then(res => {
        if (res.data.lastUpdatedDateTime) {
          //res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse = CloudService.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            userEdited: false,
            userAdded: false
          });
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "User successfully created",
            life: 3000
          });
          let typeOfUpdate = 2;
          this.updateUserList(userResponse, typeOfUpdate);
        } else {
          this.setState({ editLoaded: true });
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "An error occured creating the user, please try again",
            life: 3000
          });
        }
      });
    }
  };

  deleteUser = async () => {
    this.setState({ loaded: false });

    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("clientId");
    userRequest.userId = localStorage.getItem("userId");
    userRequest.id = this.state.userId;
    userRequest.lastUpdatedDateTime = this.state.userLastUpdatedDateTime;

    await api("userApiV1UserDeleteGlobal", userRequest).then(res => {
      let userResponse = CloudService.UserResponse.constructFromObject(
        res.data
      );
      console.log(userResponse);

      if (userResponse.errorCode === 0) {
        this.setState({
          userSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "User successfully deleted",
          life: 3000
        });
        let typeOfUpdate = 3;
        this.updateUserList(userResponse, typeOfUpdate);
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the user, please try again",
          life: 3000
        });
      }
    });
  };

  updateUserList = (apiResponse, type) => {
    let userList = this.state.userList;
    let i = 0;

    if (type === 2) {
      userList.push({
        id: apiResponse.id,
        lastUpdatedDateTime: apiResponse.lastUpdatedDateTime,
        firstName: this.state.editedUserFirstName,
        surname: this.state.editedUserSurname,
        email: this.state.editedUserEmail,
        contactTelephone: this.state.editedUserContactTelephone,
        addressLine1: this.state.editedUserAddressLine1,
        addressLine2: this.state.editedUserAddressLine2,
        town: this.state.editedUserTown,
        postcode: this.state.editedUserPostcode,
        pin: this.state.editedUserPin,
        roleType: this.state.editedUserRoleType
      });
    } else {
      this.state.userList.forEach(e => {
        if (apiResponse.id === e.id || this.state.userId === e.id) {
          if (type === 1) {
            userList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
            userList[i].firstName = this.state.editedUserFirstName;
            userList[i].surname = this.state.editedUserSurname;
            userList[i].email = this.state.editedUserEmail;
            userList[
              i
            ].contactTelephone = this.state.editedUserContactTelephone;
            userList[i].addressLine1 = this.state.editedUserAddressLine1;
            userList[i].addressLine2 = this.state.editedUserAddressLine2;
            userList[i].town = this.state.editedUserTown;
            userList[i].postcode = this.state.editedUserPostcode;
            userList[i].pin = this.state.editedUserPin;
            userList[i].roleType = this.state.editedUserRoleType;
          }
          if (type === 3) {
            userList.splice(i, 1);
          }
        }
        i++;
      });
    }

    this.setState(
      { userList: userList, loaded: true, editLoaded: true },
      () => {
        console.log(this.state.userList);
        this.setPinList();
      }
    );
  };

  selectUser = data => {
    this.setState(
      {
        selectedUser: data,
        userAddressLine1: data.addressLine1,
        userAddressLine2: data.addressLine2,
        userCodeTag: data.codeTag,
        userContactTelephone: data.contactTelephone,
        userDateCreated: data.dateCreated,
        userEmail: data.email,
        userFirstName: data.firstName,
        userId: data.id,
        userLastUpdatedDateTime: data.lastUpdatedDateTime,
        userPin: data.pin,
        userPostcode: data.postcode,
        userRoleType: data.roleType,
        userSurname: data.surname,
        userTown: data.town
      },
      () => {
        console.log(this.state.selectedUser);
      }
    );
  };

  editUser = () => {
    if (this.state.userAdded === true) {
      this.setState({
        editedUserAddressLine1: "",
        editedUserAddressLine2: "",
        editedUserContactTelephone: "",
        editedUserEmail: "",
        editedUserFirstName: "",
        editedUserPin: "",
        editedUserPostcode: "",
        editedUserRoleType: "",
        editedUserSurname: "",
        editedUserTown: ""
      });
    } else {
      this.setState({
        editedUserAddressLine1: this.state.userAddressLine1,
        editedUserAddressLine2: this.state.userAddressLine2,
        editedUserContactTelephone: this.state.userContactTelephone,
        editedUserEmail: this.state.userEmail,
        editedUserFirstName: this.state.userFirstName,
        editedUserPin: this.state.userPin,
        editedUserPostcode: this.state.userPostcode,
        editedUserRoleType: this.state.userRoleType,
        editedUserSurname: this.state.userSurname,
        editedUserTown: this.state.userTown
      });
    }
  };

  reselectUser = () => {
    if (
      this.state.selectedUser !== undefined &&
      this.state.selectedUser !== ""
    ) {
      this.state.userList.forEach(e => {
        if (this.state.userId === e.id) {
          this.setState(
            {
              userSelected: true,
              userEdited: false,
              userAdded: false
            },
            () => {
              this.selectUser(e);
            }
          );
        }
      });
    }
  };

  checkRequiredFields = () => {
    let disable = false;

    if (
      this.state.editedUserFirstName &&
      this.state.editedUserSurname &&
      this.state.editedUserEmail &&
      this.state.editedUserPin &&
      this.state.editedUserRoleType
    ) {
      disable = false;
    } else {
      disable = true;
    }

    return disable;
  };

  roleTypeEditor = () => {
    return (
      <div className="ui-g-6">
        <label className="input-label">&nbsp;Role Type *</label>
        <br />
        <pr.Dropdown
          value={this.state.editedUserRoleType}
          options={c.roleTypeOptions}
          onChange={e => {
            this.setState({
              editedUserRoleType: e.value
            });
          }}
          filter={false}
          filterBy="label"
          filterPlaceholder="Search"
          style={{ marginTop: "1px", width: "100%" }}
        />
      </div>
    );
  };

  render() {
    const s = this.state;

    return (
      <div
        className="ui-g dashboard"
        style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
      >
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <pr.Dialog
          header="Delete User"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.setState({ userDeleted: false });
                  this.deleteUser();
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ userDeleted: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.userDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ userDeleted: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        {s.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Users Card*/}
            {s.userSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>User Number: </b>
                    <label>{fo.formatId(s.userId) || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Role Type: </b>
                    <label>
                      {fo.formatRoleType(s.userRoleType) || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>First Name: </b>
                    <label>{s.userFirstName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Surname: </b>
                    <label>{s.userSurname || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Email: </b>
                    <label>{s.userEmail || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Telephone: </b>
                    <label>{s.userContactTelephone || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Address Line 1: </b>
                    <label>{s.userAddressLine1 || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Address Line 2: </b>
                    <label>{s.userAddressLine2 || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Town: </b>
                    <label>{s.userTown || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Postcode: </b>
                    <label>{s.userPostcode || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>PIN:</b>
                    <label>{s.userPin || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Edit"
                    icon="pi pi-plus"
                    onClick={() => {
                      this.setState(
                        {
                          userSelected: false,
                          userEdited: true,
                          userAdded: false
                        },
                        () => {
                          this.editUser();
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Delete"
                    icon="pi pi-trash"
                    onClick={() => {
                      this.setState({ userDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Close"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        userSelected: false,
                        userEdited: false,
                        userAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Users Card*/}
            {s.userEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserFirstName || ""}
                        onChange={e =>
                          this.setState({
                            editedUserFirstName: e.target.value
                          })
                        }
                      />
                      <label className="input-label">First Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserSurname || ""}
                        onChange={e =>
                          this.setState({
                            editedUserSurname: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Surname *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserEmail || ""}
                        onChange={e =>
                          this.setState({
                            editedUserEmail: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Email *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserContactTelephone || ""}
                        onChange={e =>
                          this.setState({
                            editedUserContactTelephone: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Telephone</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedUserAddressLine1: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Address Line 1</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedUserAddressLine2: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserTown || ""}
                        onChange={e =>
                          this.setState({
                            editedUserTown: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Town</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserPostcode || ""}
                        onChange={e =>
                          this.setState({
                            editedUserPostcode: e.target.value
                          })
                        }
                      />
                      <label className="input-label">Postcode</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedUserPin || ""}
                        onChange={e =>
                          this.setState({
                            editedUserPin: e.target.value
                          })
                        }
                      />
                      <label className="input-label">PIN *</label>
                    </span>
                  </div>
                  {s.userAdded === true ? (
                    this.roleTypeEditor()
                  ) : localStorage.getItem("userId") !== s.userId ? (
                    this.roleTypeEditor()
                  ) : (
                    <label />
                  )}
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    disabled={this.checkRequiredFields()}
                    label="Save"
                    icon={
                      s.editLoaded === false
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-check"
                    }
                    onClick={() => {
                      s.userAdded === true ? this.addUser() : this.updateUser();
                    }}
                    style={{
                      float: "right"
                    }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => {
                      s.userAdded === true
                        ? this.setState({
                            userSelected: false,
                            userEdited: false,
                            userAdded: false
                          })
                        : this.setState({
                            userSelected: true,
                            userEdited: false,
                            userAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Users Table*/}
            <div className="ui-g-12 card">
              <pr.DataTable
                value={s.userList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      userSelected: true,
                      userEdited: false,
                      userAdded: false
                    },
                    () => {
                      this.selectUser(e.data);
                    }
                  );
                }}
                selection={s.selectedUser}
                header={
                  <div className="ui-g">
                    <div className="ui-g-12">
                      <pr.Button
                        className="secondary-btn"
                        label="Create New"
                        icon="pi pi-pencil"
                        onClick={() => {
                          this.setState(
                            {
                              userSelected: false,
                              userEdited: true,
                              userAdded: true,
                              selectedUser: ""
                            },
                            () => {
                              this.editUser();
                            }
                          );
                        }}
                        style={{ float: "right" }}
                      />
                      <pr.Button
                        className="secondary-btn"
                        label="View Business Settings"
                        icon="pi pi-cog"
                        onClick={() => {
                          window.location = "#/business";
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                    <div className="ui-g-12">
                      <label className="header-label">Employees</label>
                    </div>
                  </div>
                }
                emptyMessage="No Employees"
                rows={100}
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
              >
                <pr.Column
                  field="id"
                  header="User Number"
                  body={e => {
                    return fo.formatId(e.id);
                  }}
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="firstName"
                  header="First Name"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="surname"
                  header="Surame"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="contactTelephone"
                  header="Telephone"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="addressLine1"
                  header="Address Line 1"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="addressLine2"
                  header="Address Line 2"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="town"
                  header="Town"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="postcode"
                  header="Postcode"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="pin"
                  header="PIN"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="roleType"
                  header="Role Type"
                  body={e => {
                    return fo.formatRoleType(e.roleType);
                  }}
                  sortable={true}
                  filter={true}
                  filterMatchMode="custom"
                  filterFunction={fl.filterRoleType}
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Employees/Employees.js